const INTERNAL_SOURCE_RE = /^\/api\/source\/[A-Za-z0-9:_-]+(?:\/preview)?$/;
const INTERNAL_READING_COPY_RE = /^\/api\/(?:v2\/)?reading-copy(?:\/[A-Za-z0-9@._:-]+(?:\/download)?)?$/;

export function isSafeHref(value, { internal = false } = {}) {
  if (typeof value !== "string" || !value.trim()) return false;
  const candidate = value.trim();
  try {
    const origin = globalThis.location?.origin || "http://localhost";
    const url = new URL(candidate, origin);
    if (url.protocol === "http:" || url.protocol === "https:") {
      return candidate.startsWith("/")
        ? internal && (INTERNAL_SOURCE_RE.test(url.pathname) || INTERNAL_READING_COPY_RE.test(url.pathname))
        : true;
    }
  } catch {
    return false;
  }
  return false;
}

export function publisherUrl(source = {}, fallback = "") {
  const base = [
    source.source_url,
    source.resolved_url,
    source.request_url,
    source.original_url,
    fallback,
  ].find((value) => isSafeHref(value)) || null;
  if (!base) return null;
  const anchor = source.publisher_anchor || source.source_anchor || source.anchor;
  if (!anchor) return base;
  const suffix = String(anchor).startsWith("#") ? String(anchor) : `#${anchor}`;
  return `${base.split("#")[0]}${suffix}`;
}

export function preservedFileUrl(source = {}, preview = null) {
  return [
    preview?.archive_url,
    preview?.preview_url,
    source.archive_url,
    source.archive_path,
  ].find((value) => isSafeHref(value, { internal: true })) || null;
}

/** Public reading-copy links are deliberately separate from exact source bytes. */
export function readingCopyUrl(source = {}, preview = null) {
  return [
    preview?.reading_copy_url,
    preview?.clean_reading_copy_url,
    source.reading_copy_url,
    source.clean_reading_copy_url,
    source.reading_url,
  ].find((value) => isSafeHref(value, { internal: true }) || isSafeHref(value)) || null;
}

export function downloadReadingCopyUrl(source = {}, preview = null) {
  return [
    preview?.reading_copy_download_url,
    preview?.clean_reading_copy_download_url,
    source.reading_copy_download_url,
    source.clean_reading_copy_download_url,
  ].find((value) => isSafeHref(value, { internal: true }) || isSafeHref(value)) || null;
}

export function sourceLocator(source = {}) {
  return source.source_locator || source.locator || null;
}
